module.exports = __webpack_public_path__ + "static/logo-f69819dd4b4a8e6c008211763661f294.png";